<mc-header-bar [headerModel]="headerModel" (saveEvent)="saveChanges()" (cancelEvent)="cancelChanges()"></mc-header-bar>

<div class="form-page content-container">
  <form autocomplete="off" novalidate>
    <router-outlet></router-outlet>
  </form>
</div>